export const field = {
  frontEleType: [{ // 1.文本2.下拉单选3.下拉筛选4.单选5.省市联动6.省市区联动7.日期8.日期段9.数字Range
    value: 1, label: '文本'
  }, {
    value: 2, label: '下拉单选'
  }, {
    value: 3, label: '下拉筛选'
  }, {
    value: 4, label: '单选'
  }, {
    value: 5, label: '省市联动'
  }, {
    value: 6, label: '省市区联动'
  }, {
    value: 7, label: '日期'
  }, {
    value: 8, label: '日期段'
  }, {
    value: 9, label: '数字Range'
  }, {
    value: 10, label: '组织机构（树形）'
  }, {
    value: 11, label: '日期时间段'
  }, {
    value: 12, label: '横向单选'
  }],
  ascend: [{
    value: 0, label: '降序'
  }, {
    value: 1, label: '升序'
  }],
  groupName: [{
    value: 1, label: '基本信息'
  }, {
    value: 61, label: '组织结构'
  }, {
    value: 2, label: '车辆信息'
  }, {
    value: 3, label: '被保人信息'
  }, {
    value: 4, label: '车主信息'
  }, {
    value: 5, label: '投保人信息'
  }, {
    value: 60, label: '主险种(保额/保费/折扣)'
  }, {
    value: 6, label: '保单明细\r\n险种(保额/保费/折扣)'
  }, {
    value: 7, label: '保单费用'
  }, {
    value: 8, label: '上游手续费'
  }, {
    value: 9, label: '下游手续费'
  }, {
    value: 10, label: '上游结算'
  }, {
    value: 11, label: '下游结算'
  }, {
    value: 12, label: '出单类型'
  }, {
    value: 64, label: '业务员银行卡信息'
  }, {
    value: 16, label: '付款信息'
  }, {
    value: 15, label: '商业险分类'
  }, {
    value: 13, label: '备注'
  }, {
    value: 14, label: '代理信息'
  }, {
    value: 20, label: '其他信息'
  }, {
    value: 21, label: '险种'
  }, {
    value: 62, label: '非车信息'
  }, {
    value: 63, label: '保单明细(险种/保额/保费/折扣)'
  }, {
    value: 22, label: '多级结算'
  }, {
    value: 23, label: '费用汇总'
  }, {
    value: 65, label: '营销方案'
  }, {
    value: 66, label: '代刷卡信息'
  }, {
    value: 67, label: '营销费用'
  }, {
    value: 68, label: '扩展信息'
  }, {
    value: 32, label: '日志'
  }],
  sceneCategory: [{
    value: 1, label: '保单查询'
  }, {
    value: 2, label: '保单导出'
  }, {
    value: 3, label: '上游结算报表查询'
  }, {
    value: 4, label: '上游结算报表导出'
  }, {
    value: 30, label: '下游结算报表查询'
  }, {
    value: 40, label: '下游结算报表导出'
  }, {
    value: 50, label: '下游对账申请'
  }, {
    value: 60, label: '下游对账审核'
  }, {
    value: 5, label: '财务明细报表查询'
  }, {
    value: 6, label: '财务明细报表导出'
  }, {
    value: 7, label: '非车保单查询'
  }, {
    value: 8, label: '非车保单报表导出'
  }, {
    value: 10, label: '旗舰版保单查询'
  }, {
    value: 100, label: '旗舰版保单查询导出'
  }, {
    value: 11, label: '旗舰版财务明细报表'
  }, {
    value: 110, label: '旗舰版财务明细报表导出'
  }, {
    value: 130, label: '奖励结算报表'
  }, {
    value: 132, label: '奖励结算报表导出'
  }],
  busiType: [{
    value: 1, label: '保单查询'
  }, {
    value: 3, label: '上游结算报表查询'
  }, {
    value: 30, label: '下游结算报表查询'
  }, {
    value: 50, label: '下游对账申请'
  }, {
    value: 60, label: '下游对账审核'
  }, {
    value: 5, label: '财务明细报表查询'
  }, {
    value: 200, label: '非车保单查询'
  }, {
    value: 210, label: '批量更新业务员'
  }, {
    value: 10, label: '旗舰版保单查询'
  }, {
    value: 11, label: '旗舰版财务明细报表'
  }, {
    value: 300, label: '批量导入人员'
  }, {
    value: 400, label: '批量上编任务'
  }, {
    value: 9, label: '工资导入'
  }, {
    value: 901, label: '工资导出'
  }, {
    value: 220, label: '非车保单删除'
  }, {
    value: 15, label: '车险保单删除'
  }, {
    value: 211, label: '批量更新'
  }, {
    value: 130, label: '多级结算报表'
  }, {
    value: 132, label: '多级结算报表导出'
  }, {
    value: 212, label: '批量更新'
  }, {
    value: 7, label: '报表导出列表'
  }, {
    value: 16, label: '下游财务审批'
  }, {
    value: 17, label: '下游财务打款'
  }, {
    value: 18, label: '产销结算'
  }]
}

export default {
  field
}



// WEBPACK FOOTER //
// ./src/data/field.js